// extracted by mini-css-extract-plugin
export default {"root":"FavoriteButton_root__17Akw","favorited":"FavoriteButton_favorited__O4WES","icon":"FavoriteButton_icon__fLSdN"};